import React from 'react'
import {connect} from 'react-redux'
import {List} from 'immutable'

import {
  CONVERSATION_TYPES
} from '../shared/config/constants'

import ChatListSegment from './chat_list_segment'

class ChatListAdminSegment extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  componentWillMount () {
    const {admins, count} = this.props
    if (admins || count) {
      this.setAdmins(admins, count)
    }
  }

  componentWillReceiveProps (nextProps) {
    const {admins, count} = this.props
    const {admins: nextAdmins, count: nextCount} = nextProps

    if (admins !== nextAdmins || count !== nextCount) {
      this.setAdmins(nextAdmins, nextCount)
    }
  }

  setAdmins (admins, count) {
    admins = admins
      .sortBy((a) => (a.get('name') || '').toLowerCase())
      .sortBy((a) => -1 * a.get('presence'))
      .take(parseInt(count, 10))

    this.setState({admins})
  }

  render () {
    return (
      <ChatListSegment
        label={this.props.title}
        emptyMessage='There are no online admins at the moment.'
        conversationType={CONVERSATION_TYPES.NORMAL}
        shouldShowUnreadMessageCount={false}
        list={this.state.admins}/>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    title: state.getIn(['chatSettings', 'segments', 'admins', 'title']),
    count: state.getIn(['chatSettings', 'segments', 'admins', 'numberOfUsers']),
    admins: state.getIn(['chatListView', 'segments', 'admins'], List())
  }
}

const ChatListAdminSegmentContainer = connect(
  mapStateToProps
)(ChatListAdminSegment)

export default ChatListAdminSegmentContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_list_admin_segment.js
 **/